<template>
  <div id="file-content-id" class="file-content" tabindex="-1">
    <!-- Upload Progress Indicator -->
    <div
      v-if="isUploading"
      class="upload-progress-container"
      aria-live="polite"
    >
      <div class="upload-progress-card">
        <div class="progress-spinner" aria-hidden="true">
          <font-awesome-icon icon="spinner" spin />
        </div>
        <div class="progress">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: Math.round(uploadingProgress) + '%' }"
            :aria-valuenow="Math.round(uploadingProgress)"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ Math.round(uploadingProgress) }}%
          </div>
        </div>
        <div class="upload-status">
          <template v-if="localTotal === 1">
            Įkeliamas failas...
          </template>
          <template v-else>
            Įkeliamas failas: {{ localUploaded + 1 }} iš {{ localTotal }}
          </template>
        </div>
      </div>
    </div>

    <div ref="fileContainer" class="files-container">
      <!--Item previews list-->
      <div v-if="isList" class="file-list-wrapper">
        <transition-group
          name="file"
          tag="section"
          class="file-list"
          :class="filePreviewType"
        >
          <FileItemList
            v-for="item in filterRecordByFolder"
            :key="item.unique_id"
            :item="item"
            class="file-item"
          ></FileItemList>
        </transition-group>
      </div>

      <!--Item previews grid-->
      <div v-if="isGrid" class="file-grid-wrapper">
        <transition-group
          name="file"
          tag="section"
          class="file-list"
          :class="filePreviewType"
        >
          <FileItemGrid
            v-for="item in filterRecordByFolder"
            :key="item.unique_id"
            :item="item"
            class="file-item"
            :deletable="canDeleteFile"
          ></FileItemGrid>
          <div
            v-if="canShowUploadButton"
            :key="`uplaod_${identifier}`"
            class="file-wrapper file-item file-item-upload"
          >
            <label :label="`upload_files_${identifier}`" class="file-item">
              <div class="icon-item file-icon-upload">
                <font-awesome-icon
                  class="file-icon"
                  icon="cloud-upload-alt"
                ></font-awesome-icon>
              </div>
              <div class="item-name">
                <input
                  v-show="false"
                  :id="`upload_files_${identifier}`"
                  accept="*"
                  type="file"
                  name="files[]"
                  :multiple="multiple"
                  @change="emmitFiles"
                />
                <b class="name">
                  {{ multiple ? 'Įkelti daugiau failų' : 'Įkelti failą' }}
                </b>
              </div>
            </label>
          </div>
        </transition-group>
      </div>

      <!--Show empty page if folder is empty-->

      <div class="empty-page">
        <div class="empty-state">
          <!--Shared empty message-->
          <!--      <div
            class="text-content"
            v-if="$isThisLocation(['shared']) && !isLoading"
          >
            <h1 class="title">{{ trans('shared.empty_shared') }}</h1>
          </div>-->

          <!--Trash empty message-->
          <!--      <div
            class="text-content"
            v-if="$isThisLocation(['trash', 'trash-root']) && !isLoading"
          >
            <h1 class="title">{{ trans('empty_page.title') }}</h1>
          </div>-->

          <!--Trash empty message-->
          <!--      <div
            class="text-content"
            v-if="$isThisLocation(['participant_uploads']) && !isLoading"
          >
            <h1 class="title">{{ trans('messages.nothing_from_participants') }}</h1>
          </div>-->

          <!--Base file browser empty message-->
          <div
            v-if="Object.keys(filterRecordByFolder).length == 0"
            class="text-content"
          >
            <template v-if="!maxFilesReached">
              <label label="file" class="button file-input button-base theme">
                <div data-v-35d7a0c3="" class="icon-item file-icon-on-empty">
                  <font-awesome-icon
                    class="file-icon"
                    icon="cloud-upload-alt"
                  ></font-awesome-icon>
                  <!---->
                </div>
                {{ $t('assets.button.empty-upload') }}
                <input
                  v-show="false"
                  id="file"
                  accept="*"
                  type="file"
                  name="files[]"
                  :multiple="multiple"
                  @change="emmitFiles"
                />
              </label>
            </template>
            <p v-else class="text-muted small mb-0">
              Pasiektas maksimalus leidžiamų failų skaičius.
            </p>
          </div>

          <!--Spinner-->
          <!--      <div class="text-content" v-if="isLoading">
            <Spinner></Spinner>
          </div>-->
        </div>

        <!--If file info panel empty show message-->
        <!--      <EmptyMessage
        :message="$t('messages.nothing_to_preview')"
        icon="eye-off"
      ></EmptyMessage>-->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
//import EmptyPage from '@assets/js/components/EmptyPage'
import FileItemList from '@assets/js/components/ItemList'
import FileItemGrid from '@assets/js/components/FileItemGridPreview'
//import EmptyMessage from '@assets/js/components/EmptyMessage'
import { events } from '@main/js/bus'
export default {
  name: 'FilesContainer',
  components: {
    //EmptyPage,
    FileItemList,
    FileItemGrid,
    //EmptyMessage
  },
  props: {
    uniqueFolderId: {
      type: [Number, String],
      default: null,
    },
    module: {
      type: [Number, String],
      default: null,
    },
    identifier: {
      type: [Number, String],
      default: null,
    },
    records: {
      type: Array,
      default: () => {},
    },
    filePreviewType: {
      type: String,
      default: 'grid',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    maxFiles: {
      type: [Number, String],
      default: null,
    },
    deletableOnCreate: {
      type: Boolean,
      default: true,
    },
    deletableOnEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      files: undefined,
      folder_uid: undefined,
      recordsLocal: [],
      deletedIds: new Set(),
      localUploading: false,
    }
  },
  computed: {
    ...mapGetters([
      'filesInQueueTotal',
      'filesInQueueUploaded',
      'uploadingProgress',
      'isProcessingFile',
      'fileInfoVisible',
      'fileInfoDetail',
      'currentFolder',
      'currentModule',
      'currentRecord',
      'currentElement',
      'FilePreviewType',
      'isSearching',
      'isLoading',
      'fileQueue',
    ]),
    filterRecordByFolder() {
      // recordsLocal already scoped to this.folder_uid
      return this.recordsLocal
    },
    isGrid() {
      return this.filePreviewType === 'grid'
    },
    isList() {
      return this.filePreviewType === 'list'
    },
    isEmpty() {
      return this.data.length == 0
    },
    model() {
      if (this.module == 'formrecords') {
        return this.$store.getters['form/data']
      }
      if (this.module == 'tenders') {
        return this.$store.getters['tenderForm/data']
      }
      return []
    },
    // Determine if files can be deleted
    canDeleteFile() {
      // For now, assuming 'create' mode - can be enhanced to check actual mode
      return this.deletableOnCreate
    },
    // Show upload button only if multiple is true OR no files uploaded yet
    canShowUploadButton() {
      if (!this.multiple) {
        return false
      }
      if (this.maxFilesReached) {
        return false
      }
      const hasFiles = (this.filterRecordByFolder || []).length > 0
      // Allow upload button when there are already files (for adding more)
      return hasFiles
    },
    maxFilesReached() {
      if (!this.maxFiles) return false
      const limit = Number(this.maxFiles)
      if (!Number.isFinite(limit) || limit <= 0) return false
      return (this.filterRecordByFolder || []).length >= limit
    },
    // Parent folder id of the file currently uploading (from global queue)
    currentUploadingParentId() {
      const q = this.fileQueue || []
      return q.length ? q[0].parent_id : null
    },
    // Check if files are currently uploading for THIS instance only
    isUploading() {
      const globalUploading =
        this.filesInQueueTotal > 0 ||
        this.isProcessingFile ||
        this.uploadingProgress > 0
      if (!globalUploading) return false
      // Show if this instance initiated upload or queue parent matches
      const isThisInstance =
        this.localUploading ||
        (this.folder_uid && this.currentUploadingParentId === this.folder_uid)
      return !!isThisInstance
    },
    // Upload status (instance-aware)
    localTotal() {
      // Consider this instance active if it started upload or the queue targets its folder
      const isThisInstance =
        this.localUploading ||
        (this.folder_uid && this.currentUploadingParentId === this.folder_uid)
      if (!this.multiple) {
        // For single-file widgets, always show 1 while this instance is active
        return isThisInstance ? 1 : 0
      }
      // For multiple, use global totals only when this instance is active
      return isThisInstance ? this.filesInQueueTotal || 0 : 0
    },
    localUploaded() {
      const isThisInstance =
        this.localUploading ||
        (this.folder_uid && this.currentUploadingParentId === this.folder_uid)
      if (!this.multiple) {
        // For single-file widgets, show 1 only when finished
        return isThisInstance && this.uploadingProgress >= 100 ? 1 : 0
      }
      return isThisInstance ? this.filesInQueueUploaded || 0 : 0
    },
  },
  watch: {
    uniqueFolderId(newVal) {
      if (newVal) {
        this.folder_uid = String(newVal)
        this.$store
          .dispatch('getFolderById', { folder_uid: this.folder_uid })
          .then((res) => {
            let arr = Array.isArray(res.data) ? res.data : []
            if (this.deletedIds && this.deletedIds.size) {
              arr = arr.filter(
                (i) => !this.deletedIds.has(String(i?.unique_id)),
              )
            }
            this.recordsLocal = arr
            this._syncFormBinding()
          })
          .catch(() => {})
      }
    },
    // After upload completes, refresh local records
    isProcessingFile(newVal, oldVal) {
      if (oldVal && !newVal) {
        // Upload finished (any instance)
        this.localUploading = false
      }
      if (oldVal && !newVal && this.folder_uid) {
        this.$store
          .dispatch('getFolderById', { folder_uid: this.folder_uid })
          .then((res) => {
            let arr = Array.isArray(res.data) ? res.data : []
            if (this.deletedIds && this.deletedIds.size) {
              arr = arr.filter(
                (i) => !this.deletedIds.has(String(i?.unique_id)),
              )
            }
            this.recordsLocal = arr
            this._syncFormBinding()
          })
          .catch(() => {})
      }
    },
  },
  created() {
    // Initialize folder from prop if provided
    if (this.uniqueFolderId) {
      this.folder_uid = String(this.uniqueFolderId)
      this.$store
        .dispatch('getFolderById', { folder_uid: this.folder_uid })
        .then((res) => {
          let arr = Array.isArray(res.data) ? res.data : []
          // Filter out items we already deleted locally
          if (this.deletedIds && this.deletedIds.size) {
            arr = arr.filter((i) => !this.deletedIds.has(String(i?.unique_id)))
          }
          this.recordsLocal = arr
          this._syncFormBinding()
        })
        .catch(() => {})
    }

    // React to deletions emitted by the store and remove from local records
    events.$on('file:deleted', (uniqueId) => {
      const uid = String(uniqueId)
      // Track deleted ids to ignore them on next fetch
      if (this.deletedIds) this.deletedIds.add(uid)
      this.recordsLocal = (this.recordsLocal || []).filter(
        (i) => i && String(i.unique_id) !== uid,
      )
      if (this.folder_uid) {
        this.$store
          .dispatch('getFolderById', { folder_uid: this.folder_uid })
          .then((res) => {
            let arr = Array.isArray(res.data) ? res.data : []
            if (this.deletedIds && this.deletedIds.size) {
              arr = arr.filter(
                (i) => !this.deletedIds.has(String(i?.unique_id)),
              )
            }
            this.recordsLocal = arr
            this._syncFormBinding()
          })
          .catch(() => {})
      }
    })
  },
  methods: {
    _syncFormBinding() {
      // When folder has no files, clear the form_data binding so validation fails appropriately
      try {
        if (!this.identifier || !this.model || !this.model.form_data) return
        const hasFiles =
          Array.isArray(this.recordsLocal) && this.recordsLocal.length > 0
        if (!hasFiles) {
          // Clear value when empty to prevent passing validation with stale folder id
          this.$set(this.model.form_data, this.identifier, null)
        } else if (!this.model.form_data[this.identifier] && this.folder_uid) {
          // Ensure value is set when files exist
          this.$set(this.model.form_data, this.identifier, this.folder_uid)
        }
      } catch (e) {
        /* empty */
      }
    },
    async emmitFiles(e) {
      const rawFiles = e.target.files || []
      const files = Array.from(rawFiles)
      // Mark that this instance started uploading to make overlay deterministic
      this.localUploading = true
      const existingFiles = this.filterRecordByFolder.length
      const limit = this.maxFiles ? Number(this.maxFiles) : null

      // Check for duplicate file names
      const existingFileNames = new Set(
        this.filterRecordByFolder.map((file) => file.name),
      )
      const duplicateFiles = files.filter((file) =>
        existingFileNames.has(file.name),
      )

      if (duplicateFiles.length > 0) {
        const duplicateNames = duplicateFiles.map((f) => f.name).join(', ')
        events.$emit('alert:open', {
          emoji: '',
          title: 'Failas su tokiu pavadinimu jau įkeltas',
          message: `${duplicateNames}`,
        })
        e.target.value = ''
        this.localUploading = false
        return
      }

      if (limit && Number.isFinite(limit)) {
        if (existingFiles >= limit) {
          events.$emit('alert:open', {
            emoji: '',
            title: 'Pasiektas failų limitas',
            message: `Galite įkelti ne daugiau kaip ${limit} fail${limit === 1 ? 'ą' : 'us'}.`,
          })
          e.target.value = ''
          this.localUploading = false
          return
        }
        if (files.length > limit - existingFiles) {
          events.$emit('alert:open', {
            emoji: '',
            title: 'Pasiektas failų limitas',
            message: `Galite pridėti dar ${limit - existingFiles} fail${
              limit - existingFiles === 1 ? 'ą' : 'us'
            }.`,
          })
          e.target.value = ''
          this.localUploading = false
          return
        }
      }

      // Enforce single file limit when multiple is false
      if (!this.multiple) {
        const existingFiles = this.filterRecordByFolder.length
        if (existingFiles >= 1) {
          events.$emit('alert:open', {
            emoji: '',
            title: 'Galite įkelti tik vieną failą',
            message: 'Pašalinkite esamą failą prieš įkeldami naują.',
          })
          e.target.value = '' // Reset input
          return
        }
        if (files.length > 1) {
          events.$emit('alert:open', {
            emoji: '',
            title: 'Galite įkelti tik vieną failą',
            message: 'Pasirinkite tik vieną failą.',
          })
          e.target.value = '' // Reset input
          return
        }
      }

      if (!this.folder_uid) {
        await this.$store
          .dispatch('proceedFolder', {
            module: this.module,
            no_records: true,
          })
          .then((res) => {
            this.folder_uid = res.data.unique_id
            this.model.form_data[`${this.identifier}`] = res.data.unique_id
            this.$uploadFiles(files, this.module, res.data.unique_id)
          })
      } else {
        this.model.form_data[`${this.identifier}`] = this.folder_uid
        await this.$uploadFiles(files, this.module, this.folder_uid)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.upload-progress-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  pointer-events: none;
}
.upload-progress-card {
  pointer-events: auto;
  min-width: 300px;
  max-width: 90vw;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 14px 16px;
  //box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: center;
}
.progress-spinner {
  font-size: 18px;
  color: #164194;
  margin-bottom: 8px;
}
.upload-progress-card .progress {
  height: 10px;
  margin-bottom: 8px;
}
.upload-status {
  font-size: 12px;
  color: #6c757d;
}
.empty-page {
  padding: 0 10px;
  .empty-state {
    .text-content {
      height: 100%;
      min-height: 100px;
      width: 100%;
      background: $light_background;
      border-radius: 3px;
      .file-input {
        height: 100%;
        min-height: 100px;
        width: 100%;
        margin-bottom: 0;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.file-list {
  .dragged {
    :deep(.is-dragenter) {
      border: 2px solid transparent;
    }
  }
}

.file-item-upload {
  text-align: center;
  .file-item {
    .file-icon-upload {
      margin-bottom: 13px;
    }
    .item-name {
      color: $text;
      @include font-size(13);
      font-weight: 600;
      max-height: 40px;
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &:hover {
    cursor: pointer;
    border-radius: 8px;
    background: $light_background;
  }
}

/*.file-item-upload {
  .file-item {
    .item-name {
      padding-left: 22px;
      padding-right: 22px;
      text-align: center;
      .name {
        @include font-size(14);
        color: #1b2539;
        font-weight: 600;
        max-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        line-height: 14px;
      }
    }
  }
}*/

.icon-item {
  text-align: center;
  position: relative;
  height: 115px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .file-link {
    display: block;
  }

  .file-icon {
    @include font-size(100);
    margin: 0 auto;

    path {
      fill: #fafafc;
      stroke: #dfe0e8;
      stroke-width: 1;
    }
  }

  &.file-icon-upload {
    .file-icon {
      @include font-size(60);
      margin: 20px auto 0 auto;
      path {
        fill: $color-secondary;
        stroke: $color-secondary;
        stroke-width: 1;
      }
    }
  }

  &.file-icon-on-empty {
    margin-top: 7px;
    margin-bottom: 0;
    height: 60px;
    .file-icon {
      @include font-size(50);
      margin: 0 auto;
      path {
        fill: $color-secondary;
        stroke: $color-secondary;
        stroke-width: 1;
      }
    }
  }
}

.file-content {
  display: flex;
  min-height: 100px;
  position: relative;
}

.files-container {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 0 0 100%;
  @include transition(150ms);
  position: relative;
  scroll-behavior: smooth;

  &.is-fileinfo-visible {
    flex: 0 1 100%;
  }

  .file-list {
    &.grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, 150px);
      justify-content: space-evenly;
    }
  }
}

.file-info-container {
  flex: 0 0 300px;
  padding-left: 20px;
  overflow: auto;
}

// Transition
.file-move {
  transition: transform 0.6s;
}

.file-enter-active {
  transition: all 300ms ease;
}

.file-leave-active {
  transition: all 0ms;
}

.file-enter, .file-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-20px);
}

@media only screen and (min-width: 960px) {
  /*  .file-content {
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
    bottom: 0;
    @include transition;
    overflow-y: auto;
    overflow-x: hidden;

    &.is-offset {
      margin-top: 50px;
    }
  }*/
}

@media only screen and (max-width: 960px) {
  .file-info-container {
    display: none;
  }

  .mobile-search {
    display: block;
  }
  .file-content {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include transition;
    overflow-y: auto;
    overflow-x: hidden;

    &.is-offset {
      margin-top: 50px;
    }
  }
}

@media only screen and (max-width: 690px) {
  .empty-page {
    padding: 0;
  }
  .files-container {
    padding-left: 0;
    padding-right: 0;
    /*    top: 0;
    left: 0;
    right: 0;
    bottom: 0;*/
    /* position: fixed;
    overflow-y: auto;*/

    .file-list {
      &.grid {
        grid-template-columns: repeat(auto-fill, 120px);
      }
    }
  }

  /*
  .file-content {
    position: absolute;
    top: 0;
    left: 0px;
    right: 0px;
    bottom: 0;
    @include transition;

    &.is-offset {
      margin-top: 50px;
    }
  }
*/

  .mobile-search {
    margin-bottom: 0;
  }

  .file-info-container {
    display: none;
  }
}
</style>
